// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum FuelTypeLimitationReason {
  DerivedFromVehicleRegisterData = "DERIVED_FROM_VEHICLE_REGISTER_DATA",
  VehicleNotFoundInVehicleRegister = "VEHICLE_NOT_FOUND_IN_VEHICLE_REGISTER",
  InvalidVehicleStatusInVehicleRegister = "INVALID_VEHICLE_STATUS_IN_VEHICLE_REGISTER",
  MissingOrInvalidVehicleFuelTypeInVehicleRegister = "MISSING_OR_INVALID_VEHICLE_FUEL_TYPE_IN_VEHICLE_REGISTER",
  MissingOrInvalidVehicleEmissionsInVehicleRegister = "MISSING_OR_INVALID_VEHICLE_EMISSIONS_IN_VEHICLE_REGISTER",
}
export default FuelTypeLimitationReason;
